export const tableConfig = [
  {
    title: 'Campaign Name',
    id: 'campaign_name',
  },
  {
    title: 'Country',
    id: 'countries',
  },
  {
    title: 'Coupon ID',
    id: 'id',
  },
  {
    title: 'URL',
    id: 'url',
  },
  {
    title: 'Start Date',
    id: 'starts_on',
  },
  {
    title: 'End Date',
    id: 'expires_on',
  },
  {
    title: 'Actions',
    id: 'actions',
    sorting: false,
    actions: [
      {
        text: 'Review',
        type: 'Review',
      },
    ],
  },
];

export const TableCellStates = {
  ACTIONS: 'actions',
  COUNTRIES: 'countries',
  START_DATE: 'starts_on',
  END_DATE: 'expires_on',
  URL: 'url',
};
